
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Popup from '@/components/utils/Popup.vue';

@Component({ components: { Popup } })
export default class PasswordNeededPopup extends Vue {
  currentPassword: string = '';
  newPassword: string = '';
  retryPassword: string = '';
  isPasswordInvalid = false;

  private newPasswordChanged = false;
  get isPasswordNotMatch(): boolean {
    return this.newPassword !== this.retryPassword;
  }
  get isSameNewPassword() {
    return this.newPasswordChanged && this.newPassword === this.currentPassword;
  }
  get isRequredNewPassword() {
    return this.newPasswordChanged && !this.newPassword;
  }
  private get email() {
    return this.$store.state.user.email;
  }
  get canSend(): boolean {
    return !this.isRequredNewPassword && !!this.newPassword && !this.isPasswordNotMatch;
  }
  get isInValidNewPassword(): boolean {
    return this.newPasswordChanged && this.newPassword?.length < 4;
  }
  @Watch('newPassword')
  onNewPasswordChanged() {
    this.newPasswordChanged = true;
  }

  onSendPasswordButtonClick() {
    if (!this.canSend) {
      return;
    }
    this.axios
      .post<boolean>('/zawa-data/api/changepassword', {
        email: this.email,
        password: this.currentPassword,
        newPassword: this.newPassword,
      })
      .then((res) => {
        if (res.status == 200) {
          this.close();
        } else {
          this.$toast.error('パスワードが違います。');
          this.isPasswordInvalid = true;
        }
      })
      .catch((error) => {
        this.$toast.error('パスワードが違います。');
        this.isPasswordInvalid = true;
      });
  }
  @Emit()
  close() {}
}
